





















































































































import Vue from 'vue';
import { dateTransactionFormat } from '@/constants';
import {
  UnsubstantiatedClaimResponseModel,
} from '@/@types/member';

export default Vue.extend({
  name: 'Claims',
  computed: {
    claims(): UnsubstantiatedClaimResponseModel[] {
      return this.$store.getters.unsubstantiatedClaims;
    },
    // TODO should import/create date formatting mixing like group/core
    dateTransactionFormat(): string {
      return dateTransactionFormat;
    },
  },
  mounted() {
    this.$store.dispatch('getUnsubstantiatedClaims');
  },
});
